import React, { useEffect } from 'react'
import Popup from '../../../../popup/Popup'
import {
  GAME_COMPLETE_RESULT,
  COLOR,
  GAME_COMPLETE_RESULT_GENESIS,
} from '../../../../../api-client/protocol-adapters/BoardGameProtocolAdapter'
import ContentAnonymous from './contentAnonymous/ContentAnonymous'
import ContentSignedIn from './contentSignedIn/ContentSignedIn'
import SoundManager, {
  RESULT_WIN_SOUND,
  RESULT_LOSS_SOUND,
  RESULT_DRAW_SOUND,
} from '../../../../soundManager/SoundManager'

const GameOverPopup = ({
  gameResult,
  playerColor,
  signInPage,
  isAnonymous,
  onClose,
  onNewGame,
  onNewArenaGame,
  isAllPiecesCaptured,
  player,
  gameIcon,
  tournament,
}) => {
  const isWhite = playerColor === COLOR.WHITE
  const config = {
    [GAME_COMPLETE_RESULT.DRAW]: {
      title: 'Draw',
      icon: 'draw',
      sound: RESULT_DRAW_SOUND,
    },
    [GAME_COMPLETE_RESULT.WHITE_WIN]: {
      title: isWhite ? 'You won!' : 'You lost!',
      icon:
        gameResult.genesis === GAME_COMPLETE_RESULT_GENESIS.SURRENDER &&
        !isAnonymous
          ? 'surrender'
          : null,
      win: isWhite,
      sound: isWhite ? RESULT_WIN_SOUND : RESULT_LOSS_SOUND,
    },
    [GAME_COMPLETE_RESULT.BLACK_WIN]: {
      title: !isWhite ? 'You won!' : 'You lost!',
      icon:
        gameResult.genesis === GAME_COMPLETE_RESULT_GENESIS.SURRENDER &&
        !isAnonymous
          ? 'surrender'
          : null,
      win: !isWhite,
      sound: !isWhite ? RESULT_WIN_SOUND : RESULT_LOSS_SOUND,
    },
    [GAME_COMPLETE_RESULT.NO_RESULT]: {
      title: 'Game complete',
    },
  }[gameResult.result]

  useEffect(() => {
    SoundManager.stopAll()
    config.sound && SoundManager.play(config.sound)

    return () => SoundManager.stopAll()
  }, [config.sound])

  const signUp = () => {
    signInPage
      ? (window.location.href = signInPage)
      : console.error('No props.signInPage')
  }

  const showArenaRanking = () => {
    Object.keys(tournament).length !== 0
      ? (window.location.href = `/tournaments/${tournament.id}`)
      : console.error('No props.tournament')
  }

  return (
    <Popup
      className={isAnonymous ? "game-over-anonymous" : Object.keys(tournament).length !== 0 ? "game-over-arena game-over-login" : "game-over-login"}
      // iconClass={config.icon}
      title={config.title}
      subtitle={
        isAnonymous ? 'Sign up to enjoy full access of Checkers.online!' : null
      }
      buttons={
        isAnonymous
          ? [{ text: 'Sign up', handler: signUp }]
          : Object.keys(tournament).length !== 0
            ? [{ text: 'See ranking', handler: showArenaRanking, secondary: 'secondary'}, { text: 'Next game', handler: onNewArenaGame }]
            : [{ text: 'New game', handler: onNewGame }]
      }
      onClose={onClose}
      size="wide"
    >
      {isAnonymous ? (
        <ContentAnonymous />
      ) : (
          <ContentSignedIn
            type={gameResult.genesis}
            win={config.win}
            isAllPiecesCaptured={isAllPiecesCaptured}
            player={player}
            gameIcon={gameIcon}
            tournament={tournament}
          />
      )}
    </Popup>
  )
}

export default GameOverPopup
